module.exports = {

    API: 'https://cbapiproduction.centerteam.com/api'

};



// WEBPACK FOOTER //
// ./client/app/config.js